import { useMutation } from "@tanstack/react-query";

import { Chat } from "@/types";
import { useNotify } from "react-admin";
import { FilesApi } from "@/api/files";
import { ChatsApi } from "@/api/chats";

const useUploadVideo = () => {
  const notify = useNotify();

  const { mutate, isPending } = useMutation({
    mutationFn: async ({
      chatId,
      videoFile,
    }: {
      chatId: Chat["id"];
      videoFile: File;
    }) => {
      const videoFormData = new FormData();
      videoFormData.append("file", videoFile);

      const videoFileSource = await FilesApi.uploadVideo(videoFormData);
      await ChatsApi.sendMessage({
        chatId,
        attachments: [videoFileSource],
        isViewOnce: false,
        body: "Video attachment",
      });
    },
    onError: (error) => {
      notify(error, { type: "error" });
    },
  });

  return { uploadVideo: mutate, isUploadVideoLoading: isPending };
};

export { useUploadVideo };
